import { useBnbSelector } from "../../../redux/store";
import CarDataConsolidator from "../../../../../shared-logic/utils/classes/CarDataConsolidator";
import type { ExtraType, PackType, PriceType } from "../../../../../../common-deprecated/types/CommonTypes";
import { find } from "../../../../../../common-deprecated/utils";
import { addPrices, getPriceFromExtra } from "../../../../../shared-logic/utils/priceUtils";
import type { FinancePackConfigurablesType } from "../../../../../shared-logic/types/FinanceTypes";

type BasketPackExtrasType = {
    packs: PackType[];
    extras: ExtraType[];
    packExtras: ExtraType[];
    totalPackPrice: PriceType;
    totalExtraPrice: PriceType;
    getPackName: (pack: PackType) => string;
    getExtraName: (extra: ExtraType) => string;
};
const useBasketPackExtras = (): BasketPackExtrasType => {
    const items = useBnbSelector((state) => state.items);
    const basket = useBnbSelector((state) => state.basket);
    const settings = useBnbSelector((state) => state.commonSettings);

    const packs = basket.packs.map((pack) => {
        return {
            ...pack,
            price: CarDataConsolidator.getPackAccessoryUpholsteryPrice(pack, items.upholsteries),
        };
    });

    const financePacksExtras = items.financePacks.reduce((packEquipment, pack) => {
        return [...packEquipment, ...pack.equipment];
    }, [] as FinancePackConfigurablesType[]);

    // Filter the extras that are defined in the financePacks.
    const extras = basket.extras
        .filter((extra) => !CarDataConsolidator.hideExtra(extra, settings))
        .filter((extra) => !find(extra.id, financePacksExtras));
    const packExtras = basket.packExtras.filter((extra) => !extra.isUpholstery);

    const totalPackPrice = addPrices(packs.map((pack) => pack.price).concat(packExtras.map((extra) => extra.price)));
    const totalExtraPrice = addPrices(extras.map((extra) => getPriceFromExtra(extra)));

    const { primaryAccentColour, secondaryAccentColour } = basket;
    const getPackName = (pack: PackType): string =>
        `${pack.name}${pack.extended ? " -" : ""}` +
        `${pack.extended && primaryAccentColour ? ` ${primaryAccentColour.name}` : ""}` +
        `${pack.extended && secondaryAccentColour ? ` ${secondaryAccentColour.name}` : ""}`;

    const getExtraName = (extra: ExtraType): string => {
        if (extra.options.length) {
            const option = find(extra.selectedOptionId, extra.options);
            if (option) return `${extra.name} - ${option.name}`;
        }
        return extra.name;
    };

    return { packs, extras, packExtras, totalPackPrice, totalExtraPrice, getPackName, getExtraName };
};

export default useBasketPackExtras;
